import { createFileRoute } from '@tanstack/react-router'
import { ExpenseDashboard } from '@/components/admin/ExpenseDashboard'
import { resolveExpenseTab, type ExpensesSearch } from '@/components/admin/expenses/expensesRouteSearch'

export type { ExpenseTab, ExpensesSearch } from '@/components/admin/expenses/expensesRouteSearch'

// F-FE-N129: the dashboard's tab, the ledger's category filter and the shared
// period bar all live in the URL, so a Reports tile, a "Spend by category"
// row or the P&L breakdown can deep-link into exactly the rows behind a
// number — and the link is shareable. Malformed values are dropped.
export const Route = createFileRoute('/admin/expenses')({
  validateSearch: (search: Record<string, unknown>): ExpensesSearch => {
    const str = (v: unknown) => (typeof v === 'string' && v.trim() !== '' ? v.trim() : undefined)
    const out: ExpensesSearch = {}
    const tab = resolveExpenseTab(search.tab)
    if (tab) out.tab = tab
    const category = str(search.category)
    if (category && /^[a-z0-9_]+$/i.test(category)) out.category = category
    const preset = str(search.preset)
    if (preset) out.preset = preset
    const from = str(search.from)
    if (from) out.from = from
    const to = str(search.to)
    if (to) out.to = to
    const receipt = str(search.receipt)
    if (receipt && /^[0-9a-f-]{36}$/i.test(receipt)) out.receipt = receipt
    // A category alone means "show me those rows".
    if (out.category && !out.tab) out.tab = 'ledger'
    return out
  },
  component: ExpenseDashboard,
})
